import React from 'react';
type Testimonial = {
  name: string;
  age: string;
  quote: string;
  avatar: string; // URL de la foto
};
export function TestimonialsSection() {
  const testimonials: Testimonial[] = [{
    name: 'María',
    age: '42 años',
    quote: 'Volví a sentir mi fe. Después de años sintiéndome vacía en mi vida espiritual, este libro me devolvió esa conexión que creía perdida. Ahora mis mañanas tienen sentido.',
    avatar: 'https://i.postimg.cc/02rpcnck/maria.jpg'
  }, {
    name: 'Luis',
    age: '36 años',
    quote: 'Esto no es un libro… es un camino. Cada día me sorprendo con la profundidad de las reflexiones. Es como tener un mentor espiritual que me guía paso a paso.',
    avatar: 'https://i.postimg.cc/90ct1jzH/luis.jpg'
  }, {
    name: 'Andrea',
    age: '29 años',
    quote: 'Mis mañanas cambiaron para siempre. Antes me levantaba con ansiedad. Ahora empiezo el día con paz, propósito y una conexión real con Dios.',
    avatar: 'https://i.postimg.cc/ZYMKmxFn/andrea.jpg'
  }, {
    name: 'Carlos',
    age: '47 años',
    quote: 'Pensé que ya lo había intentado todo. Pero estos 30 días me ayudaron a ordenar mi mente, sanar heridas del pasado y volver a hablar con Dios sin miedo.',
    avatar: 'https://i.postimg.cc/vmgCW5x0/carlos.jpg'
  }, {
    name: 'Sofía',
    age: '33 años',
    quote: 'Lo que más me gusta es que es práctico. No son solo palabras bonitas, sino ejercicios y reflexiones que me hicieron actuar y transformar mi día a día.',
    avatar: 'https://i.postimg.cc/yYRnBBSq/sofia.jpg'
  }, {
    name: 'Javier',
    age: '51 años',
    quote: 'Había perdido la esperanza, pero este proceso me recordó que nunca es tarde para empezar de nuevo con Dios. Cada audio y cada página me dieron paz.',
    avatar: 'https://i.postimg.cc/NfQLGkK8/javier.jpg'
  }];
  return <section className="section-card" data-id="element-135">
      <div className="max-w-5xl mx-auto text-center mb-10" data-id="element-136">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-137">
          Lo Que Dicen Quienes Ya Empezaron
        </h2>
        <p className="text-blue-100 text-lg" data-id="element-138">
          Miles de personas ya están transformando su fe día a día.
        </p>
      </div>

      <div className="max-w-6xl mx-auto grid gap-8 md:grid-cols-3" data-id="element-139">
        {testimonials.map((t, index) => <div key={index} className="bg-gradient-to-b from-indigo-900/70 to-indigo-950/80 rounded-3xl p-6 md:p-7 shadow-xl border border-white/5 flex flex-col h-full" data-id="element-140">
            {/* Avatar + nombre */}
            <div className="flex items-center gap-4 mb-4" data-id="element-141">
              <img src={t.avatar} alt={`Foto de ${t.name}`} className="h-14 w-14 rounded-full object-cover border-2 border-yellow-400 shadow-md" data-id="element-142" />
              <div className="text-left" data-id="element-143">
                <p className="text-white font-semibold text-lg" data-id="element-144">{t.name}</p>
                <p className="text-blue-200 text-sm" data-id="element-145">{t.age}</p>
              </div>
            </div>

            {/* Estrellas */}
            <div className="flex items-center gap-1 mb-3 text-yellow-300" data-id="element-146">
              <span data-id="element-147">★★★★★</span>
            </div>

            {/* Texto del testimonio */}
            <p className="text-blue-100 text-sm md:text-base leading-relaxed" data-id="element-148">
              “{t.quote}”
            </p>
          </div>)}
      </div>
    </section>;
}
export default TestimonialsSection;